import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type LinksBundleProps = {
  className?: string
}

export const LinksBundle: React.FC<LinksBundleProps> = ({ className, children }) => (
  <div className={cn(styles.Wrapper, className)}>{children}</div>
)
